document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-announcement-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      var section = button.closest('.announcement-bar-section');
      if (section) {
        section.style.display = 'none';
      }
      try {
        window.localStorage.setItem('announcementBarDismissed', 'true');
      } catch (e) {
        // localStorage unavailable, dismissal just won't persist
      }
    });
  });
});
